<div class="text-center mat-bg-primary pt-4 pb-4">
  <h2 class="m-0">Notifications</h2>
</div>
<mat-nav-list class="notification-list" role="list">
  <!-- Notification item -->
  @for (n of notifications; track n) {
    <mat-list-item class="notific-item" role="listitem" routerLinkActive="open">
      <mat-icon [color]="n.color" class="notific-icon mr-4">{{n.icon}}</mat-icon>
      <a [routerLink]="[n.route || '/dashboard']">
        <div class="mat-list-text">
          <h3 class="message">{{n.message}}</h3>
          <small class="time text-muted">{{n.time}}</small>
        </div>
      </a>
    </mat-list-item>
  }
</mat-nav-list>
@if (notifications.length) {
  <div class="text-center mt-4">
    <button type="button" mat-button (click)="clearAll($event)">Clear all notifications</button>
  </div>
}